import React, { lazy, Suspense } from "react";
import { useRecoilValue } from "recoil";
import { Tab } from "src/common/types/menu";
import { openTabsState } from "src/states/menu";
import PrivateRoute from "./PrivateRoute";
import useScreenList from "src/common/hooks/useScreenList";

const TabContents = () => {
  const openTabs = useRecoilValue(openTabsState);
  const { data: screenList } = useScreenList();

  const componentMap = React.useMemo(() => {
    const map = new Map<string, React.LazyExoticComponent<any>>();
    for (const screen of screenList) {
      if (screen?.filePath) {
        map.set(
          screen?.path || "",
          lazy(() => import(`src/pages${screen.filePath}`))
        );
      }
    }
    return map;
  }, [screenList]);

  return (
    <>
      {openTabs.map((tab: Tab) => {
        const Component = componentMap.get(tab.path);
        if (!Component) return null;

        return (
          <PrivateRoute
            key={tab.id}
            component={
              <Suspense>
                <div
                  key={tab.id}
                  style={{
                    display: "block",
                    visibility: tab.isSelected ? "visible" : "hidden",
                    position: tab.isSelected ? "static" : "absolute",
                    left: tab.isSelected ? "0" : "-9999px",
                  }}
                >
                  <Component />
                </div>
              </Suspense>
            }
          />
        );
      })}
    </>
  );
};

export default TabContents;
